<script>
  import { onMount, afterUpdate } from "svelte";
  import Chart from "chart.js/auto";

  export let title = "Portfolio Allocation";
  export let data = [];

  let chartCanvas;
  let chart;

  // Moira chart palette — keep in sync with AppColors.chartColors (THEME.md §2)
  const colors = [
    "#10B981", "#6366F1", "#F59E0B", "#EC4899",
    "#8B5CF6", "#06B6D4", "#EF4444", "#84CC16",
  ];

  function createChart() {
    if (chart) {
      chart.destroy();
    }

    const labels = data.map(d => d.symbol);
    const values = data.map(d => d.percentage);
    const backgroundColors = data.map((_, i) => colors[i % colors.length]);

    chart = new Chart(chartCanvas, {
      type: "doughnut",
      data: {
        labels,
        datasets: [{
          data: values,
          backgroundColor: backgroundColors,
          borderWidth: 2,
          borderColor: "#FFFFFF",
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "right",
            labels: {
              usePointStyle: true,
              pointStyleWidth: 8,
              boxHeight: 8,
              padding: 16,
              color: "#6B7280",
              font: { family: "Inter", size: 12 },
            },
          },
          tooltip: {
            backgroundColor: "#1F2937",
            cornerRadius: 8,
            padding: 10,
            titleFont: { family: "Inter", size: 12, weight: "600" },
            bodyFont: { family: "Inter", size: 12 },
            callbacks: {
              label: function(context) {
                return `${context.label}: ${context.parsed}%`;
              }
            }
          }
        },
        cutout: "65%",
      },
    });
  }

  onMount(() => {
    if (data.length > 0) {
      createChart();
    }
  });

  afterUpdate(() => {
    if (data.length > 0) {
      createChart();
    }
  });
</script>

<div class="card card-pad h-full">
  <p class="text-xs font-semibold uppercase tracking-wider text-ink-tertiary">
    Allocation
  </p>
  <h3 class="text-lg font-semibold text-ink mt-1 mb-4">
    {title}
  </h3>
  <div class="relative h-350-px">
    {#if data.length > 0}
      <canvas bind:this={chartCanvas}></canvas>
    {:else}
      <div class="flex flex-col items-center justify-center h-full text-center">
        <i class="fas fa-chart-pie text-2xl text-ink-tertiary mb-3"></i>
        <p class="text-sm text-ink-secondary">No allocation data yet</p>
      </div>
    {/if}
  </div>
</div>
